var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferOutgoing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18H14V16.5H3.5V7.5H20.5V12H22V7.5C22 6.67157 21.3284 6 20.5 6H3.5C2.67157 6 2 6.67157 2 7.5V16.5C2 17.3284 2.67157 18 3.5 18Z",
    fill: "#777D87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "#777D87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5303 20.7803L23.0607 17.25L19.5303 13.7197L18.4697 14.7803L20.1893 16.5H16V18H20.1893L18.4697 19.7197L19.5303 20.7803Z",
    fill: "#777D87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferOutgoing);
export default __webpack_public_path__ + "static/media/transfer-outgoing.c3cf59f185f976427254a6d487f70977.svg";
export { ForwardRef as ReactComponent };